import React from 'react';

const Accounts = () => {
  return (
    <div className="content-header">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Accounts</h1>
      <div className="box box-primary">
        <div className="box-header with-border">
          <h3 className="box-title">Accounts Management</h3>
        </div>
        <div className="box-body">
          <p className="text-gray-700">Accounts content will be displayed here</p>
        </div>
      </div>
    </div>
  );
};

export default Accounts;

